//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <div v-if="dataIsLoadedAndCalculated == true" style="width:100%;">

      <p style="font-size:16px; padding-bottom:20px;">Заявки</p>

      <div style="width:130px; font-family:'Roboto Light';font-size:13px; padding-bottom:5px; float:left;">
        Активных заявок :
      </div>
      <div style="width:calc(100%-130px); font-family:'Roboto Light'; font-size:13px; padding-bottom:7px; left:clear;">
        {{numActiveFinixTasks}}</b>
      </div>

      <div style="width:130px; font-family:'Roboto Light';font-size:13px; padding-bottom:5px; float:left;">
        Новых заявок :
      </div>
      <div style="width:calc(100%-130px); font-family:'Roboto Light'; font-size:13px; padding-bottom:7px; left:clear;">
        {{numNewActiveFinixTasks}}</b>
      </div>

      <div style="width:130px; font-family:'Roboto Light';font-size:13px; padding-bottom:5px; margin-top:20px; float:left;">
        Заявок в архиве:
      </div>
      <div style="width:calc(100%-130px); font-family:'Roboto Light'; font-size:13px; padding-bottom:7px; margin-top:20px; left:clear;">
        {{numArchivedFinixTasks}}</b>
      </div>

    </div>

    <div v-else style="width:100%;" class="one-news">
      <p style="font-size:16px; padding-bottom:20px;">Заявки</p>
      Загружаем данные...
    </div>

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import serverData from '@/store/serverData'

export default {
  data () {
    return {
      data: null,
      dataIsLoadedAndCalculated: false,

      numActiveFinixTasks: 0,
      numNewActiveFinixTasks: 0,
      numArchivedFinixTasks: 0
    }
  },
  computed: {
    ...mapGetters([
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    var thisRef = this
    this.data = serverData.tasks // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event FinixTasksChanged

    serverData.eventsBus.$on('mainCommonDataLoaded', (data) => {
      if (serverData.loadingDataStatus.tasks === serverData.loadingDataStatus.types.LOADED) thisRef.calcData()
    })

    serverData.eventsBus.$on('tasksChanged', (data) => {
      if (serverData.loadingDataStatus.mainCommonData === serverData.loadingDataStatus.types.LOADED) thisRef.calcData()
    })

    // если это не перезагрузка данной страницы то serverData уже давно бы был и тут бы мы строили список наших отображаемых данных
    // но это только для CommonData, т е тех что загружаются в приложени по умолчанию. а наши данные надо тут указать что грузим
    // thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    serverData.tasksReload(function () {
    }) // вместо callback функционал сработает через serverData.eventsBus.$on('tasksChanged')
  },
  methods: {
    calcData (body) {
      this.numActiveFinixTasks = 0
      this.numNewActiveFinixTasks = 0
      this.numArchivedFinixTasks = 0

      if (this.data.length === 0) return

      for (let i = 0; i <= this.data.length - 1; i++) {
        if (this.data[i].val.belongsToBoard !== serverData.appSettings.finix.finixOrdersTaskBoard) continue // Убираем тех что не на доске заявок
        if (this.data[i].val.type !== serverData.appSettings.tasks.taskTypes.FINIX_ORDER) continue // Убираем тех что НЕ ЗАЯВКИ

        if (this.data[i].val.deleted === true) {
          this.numArchivedFinixTasks++
          continue
        }

        if (this.activeUser.GroupID === serverData.appSettings.finix.userGroups.SALERS) {
          if (this.data[i].val.body.finix.saler === this.activeUser.id) {
            this.numActiveFinixTasks++
            if (this.data[i].val.body.status === serverData.appSettings.finix.finixOrdersNewTaskStatus) this.numNewActiveFinixTasks++
          }
        } else if (this.activeUser.GroupID === serverData.appSettings.finix.userGroups.MANAGERS) {
          if (this.data[i].val.body.finix.manager === this.activeUser.id) {
            this.numActiveFinixTasks++
            if (this.data[i].val.body.status === serverData.appSettings.finix.finixOrdersNewTaskStatus) this.numNewActiveFinixTasks++
          }
        } else {
          this.numActiveFinixTasks++
          if (this.data[i].val.body.status === serverData.appSettings.finix.finixOrdersNewTaskStatus) this.numNewActiveFinixTasks++
        }
      }

      this.dataIsLoadedAndCalculated = true
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// FinixTasksReport.vue?13693e3b